import React, { useState } from 'react';
import { Button, Icon, Menu } from '@fairygodboss/ui';
import window from 'global/window';

import { createIcsFile, getAddToCalendarLinks, CALENDARS } from './helpers';
import {
    GoogleCalendarSVG,
    AppleCalendarSVG,
    YahooCalendarSVG,
    OutlookCalendarSVG,
} from './MenuSVGs';
import { EmitMetric } from '../../../Analytics/VisibilityPixel/VisibilityPixel';

export const AddToCalendarButton = ({ event, children, ...buttonProps }) => {
    const [isOpen, setIsOpen] = useState(false);
    const handleClick = (visibility) => {
        setIsOpen(visibility);
    };

    const handleItemClick = (item) => {
        let link = null;
        switch (item.itemId) {
            case CALENDARS.GOOGLE.id:
                link = getAddToCalendarLinks(event).google;
                break;
            case CALENDARS.APPLE.id:
                createIcsFile(event);
                break;
            case CALENDARS.OUTLOOK.id:
                link = getAddToCalendarLinks(event).outlook;
                break;
            case CALENDARS.YAHOO.id:
                link = getAddToCalendarLinks(event).yahoo;
                break;
            default:
                break;
        }

        if (link) {
            window.open(link, '_blank');
        }

        EmitMetric({
            misc_event_count: 1,
            misc_event_type: 'add-to-calendar',
            event_id: event.id,
        });
    };

    const createMenuItems = () => {
        return [
            {
                itemId: CALENDARS.GOOGLE.id,
                itemIconChild: <GoogleCalendarSVG />,
                itemMetricFunction: () => null,
                itemText: CALENDARS.GOOGLE.itemText,
                onClick: handleItemClick,
            },
            {
                itemId: CALENDARS.APPLE.id,
                itemIconChild: <AppleCalendarSVG />,
                itemMetricFunction: () => null,
                itemText: CALENDARS.APPLE.itemText,
                onClick: handleItemClick,
            },
            {
                itemId: CALENDARS.OUTLOOK.id,
                itemIconChild: <OutlookCalendarSVG />,
                itemMetricFunction: () => null,
                itemText: CALENDARS.OUTLOOK.itemText,
                onClick: handleItemClick,
            },
            {
                itemId: CALENDARS.YAHOO.id,
                itemIconChild: <YahooCalendarSVG />,
                itemMetricFunction: () => null,
                itemText: CALENDARS.YAHOO.itemText,
                onClick: handleItemClick,
            },
        ];
    };

    if (children) {
        return (
            <Menu items={createMenuItems()} onVisibilityChange={handleClick}>
                {children}
            </Menu>
        );
    }

    if (buttonProps.size) {
        return (
            <Menu
                items={createMenuItems()}
                onVisibilityChange={handleClick}
                width={buttonProps.width}
            >
                <Button {...buttonProps}>Add to Calendar</Button>
            </Menu>
        );
    }

    return (
        <Menu items={createMenuItems()} onVisibilityChange={handleClick}>
            <Button
                padding="14px 20px 14px 28px"
                marginRight="20px"
                fontSize="16px"
                lineHeight="20px"
                fontWeight="600"
                variant="primary"
                tabIndex="0"
                css={{
                    backgroundColor: isOpen ? '#7D268B' : '#982EA9',
                }}
                rightIcon={
                    <Icon
                        outlineColor="#FFFFFF"
                        variant={isOpen ? 'chevron_up_16' : 'chevron_down_16'}
                    />
                }
                {...buttonProps}
            >
                Add to Calendar
            </Button>
        </Menu>
    );
};

AddToCalendarButton.displayName = 'AddToCalendarButton';
